module.exports = __webpack_public_path__ + "img/banner.10866550.jpg";